<form-control-container #container [control]="controlInstance" [class.readonly]="isReadonlyValue"
                       [class.useButtons]="allowNull || useButtons">
      <div label-extension>
        <ng-content select="[label-extension]"></ng-content>
      </div>
      <ng-container *ngIf="!isReadonlyValue">
    
        <button
                *ngIf="!allowNull && !useButtons"
                [id]="controlId"
                [class]="controlIndicatorClass"
                [attr.tabindex]="tabindex"
                [class.checked]="value"
                [disabled]="disabled"
                (click)="onClick();false;"></button>
    
        <div class="nullable-container btn-group" *ngIf="allowNull || useButtons">
          <button type="button" class="btn btn-sm btn-default" [disabled]="disabled" [class.activated]="value"
                  (click)="value = true">{{trueText}}</button>
          <button type="button" class="btn btn-sm btn-default" [disabled]="disabled"
                  [class.activated]="!value && value!=null" (click)="value = false">{{falseText}}</button>
          <button type="button" class="btn btn-sm btn-default" [disabled]="disabled" [class.activated]="value==null"
                  (click)="value = null" *ngIf="allowNull">{{nullText}}</button>
        </div>
      </ng-container>
    
      <ng-container *ngIf="isReadonlyValue">
        <span class="readonly-value" innerHTML="{{value | boolToDisplayValue}}"></span>
      </ng-container>
    
    </form-control-container>